var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_header"},[_c('h2',{staticClass:"content_header__title"},[_vm._t("title")],2),_c('div',{staticClass:"content_header__action"},[_vm._t("action",function(){return [(_vm.$slots.action)?_c('v-btn',{attrs:{"outlined":""}},[_vm._t("action")],2):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }